import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

/* eslint-disable camelcase */
import { decomposeCompositeGLType } from '../webgl-utils/attribute-utils';
import assert from '../utils/assert';
var ERR_ARGUMENT = 'UniformBufferLayout illegal argument'; // Local constants - these will "collapse" during minification

var GL_FLOAT = 0x1406;
var GL_INT = 0x1404;
var GL_UNSIGNED_INT = 0x1405; // Std140 layout for uniforms

var UniformBufferLayout =
/*#__PURE__*/
function () {
  function UniformBufferLayout(layout) {
    var _this$typedArray;

    _classCallCheck(this, UniformBufferLayout);

    this.layout = {};
    this.size = 0; // Add layout (type, size and offset) definitions for each uniform in the layout

    for (var key in layout) {
      this._addUniform(key, layout[key]);
    } // Allocate three typed arrays pointing at same memory


    var data = new Float32Array(this.size);
    this.typedArray = (_this$typedArray = {}, _defineProperty(_this$typedArray, GL_FLOAT, data), _defineProperty(_this$typedArray, GL_INT, new Int32Array(data.buffer)), _defineProperty(_this$typedArray, GL_UNSIGNED_INT, new Uint32Array(data.buffer)), _this$typedArray);
  } // Get number of bytes needed for buffer allocation


  _createClass(UniformBufferLayout, [{
    key: "getBytes",
    value: function getBytes() {
      return this.size * 4;
    } // Get the current data as Float32Array, for bufferSubData

  }, {
    key: "getData",
    value: function getData() {
      return this.typedArray[GL_FLOAT];
    } // Get offset and data for one object (for bufferSubData)

  }, {
    key: "getSubData",
    value: function getSubData(index) {
      var data;
      var offset;

      if (index === undefined) {
        data = this.data;
        offset = 0;
      } else {
        var begin = this.offsets[index];
        var end = begin + this.sizes[index];
        data = this.data.subarray(begin, end);
        offset = begin * 4;
      }

      return {
        data: data,
        offset: offset
      };
    } // Set a map of values

  }, {
    key: "setUniforms",
    value: function setUniforms(values) {
      for (var key in values) {
        this._setValue(key, values[key]);
      }

      return this;
    }
  }, {
    key: "_setValue",
    value: function _setValue(key, value) {
      var layout = this.layout[key];
      assert(layout, 'UniformLayoutStd140 illegal argument');
      var typedArray = this.typedArray[layout.type];

      if (layout.size === 1) {
        // single value -> just set it
        typedArray[layout.offset] = value;
      } else {
        // vector/matrix -> copy the supplied (typed) array, starting from offset
        typedArray.set(value, layout.offset);
      }
    }
  }, {
    key: "_addUniform",
    value: function _addUniform(key, uniformType) {
      var typeAndComponents = decomposeCompositeGLType(uniformType);
      assert(typeAndComponents, ERR_ARGUMENT);
      var type = typeAndComponents.type,
          count = typeAndComponents.components; // First, align (bump) current offset to an even multiple of current object (1, 2, 4)

      this.size = this._alignTo(this.size, count); // Use the aligned size as the offset of the current uniform.

      var offset = this.size; // Then, add our object's padded size ((1, 2, multiple of 4) to the current offset

      this.size += count;
      this.layout[key] = {
        type: type,
        size: count,
        offset: offset
      };
    } // Align offset to 1, 2 or 4 elements (4, 8 or 16 bytes)

  }, {
    key: "_alignTo",
    value: function _alignTo(size, count) {
      switch (count) {
        case 1:
          return size;
        // Pad upwards to even multiple of 2

        case 2:
          return size + size % 2;
        // Pad upwards to even multiple of 2

        default:
          return size + (4 - size % 4) % 4;
        // Pad upwards to even multiple of 4
      }
    }
  }]);

  return UniformBufferLayout;
}();

export { UniformBufferLayout as default };
//# sourceMappingURL=uniform-buffer-layout.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/webgl/uniform-buffer-layout.js
// module id = 1611
// module chunks = 0